import styled from '@emotion/styled';

interface BadgeTagsProps {
  text: string;
  width?: string;
  height?: string;
}

const Tag = styled.div<{ width?: string; height?: string }>`
  display: flex;
  height: ${(props) => props.height || '24px'};
  padding: 2px 6px;
  align-items: center;

  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: linear-gradient(87deg, #f0e5bb 0%, #ffca00 100%);

  color: #000;
  font-size: clamp(10px, 1.5vw, 12px);
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  z-index: 9;
`;

const BadgeTags = ({ text, width, height }: BadgeTagsProps) => {
  return (
    <Tag width={width} height={height}>
      {text}
    </Tag>
  );
};

export default BadgeTags;
